const statusOf = (value) => value?.response?.status ?? value?.status;
const messageOf = (value, fallback) => {
  const body = value?.response?.data ?? value?.data;
  return body?.errors?.[0]?.message || body?.message || value?.message || fallback;
};
const transitionError = (message, cause, details) => Object.assign(new Error(message), { cause, ...details });

export function createSurveyCryptoTransitionService({ apiClient, apiUrl, interpolateURL }) {
  const url = interpolateURL({ apiUrl, endpoint: "change-master-key", id: null, omitLanguage: true });

  async function apply({ payload }) {
    let outcome = null;
    const setOutcome = (next) => {
      if (!outcome) outcome = next;
    };
    try {
      await apiClient({
        mode: "resolution",
        method: "POST",
        url,
        hash: payload.oldMasterKey.companyHash,
        body: payload,
        ignoreError: true,
        onSuccess: (response) => setOutcome({ succeeded: true, response }),
        onError: (error) => setOutcome({ succeeded: false, error }),
      });
    } catch (error) {
      setOutcome({ succeeded: false, error });
    }

    if (outcome?.succeeded) return { state: "target", response: outcome.response };

    const error = outcome?.error;
    const requestSent = error?.requestSent !== false;
    throw transitionError(
      messageOf(error, outcome ? "Survey crypto transition failed" : "The Survey API client did not report a transition outcome"),
      error,
      {
        requestSent,
        failureStage: "survey-transition",
        httpStatus: statusOf(error),
        safeToContinue: !requestSent,
        requiresRecovery: requestSent,
        persistenceState: requestSent ? "unknown" : "source",
        code: outcome ? (requestSent ? "TRANSITION_RESULT_UNKNOWN" : "TRANSITION_NOT_SENT") : "TRANSITION_OUTCOME_MISSING",
      }
    );
  }

  return { apply };
}
